// Whether the current document is the Mo embed shell (the Salespath iframe), signalled by the
// `data-mo-embedded` attribute the shell stamps on <body>. The shell does not exist yet, so this
// is always false in the normal admin — callers that branch on it stay dormant until it ships.
// Keep this the single place that reads the flag, and share it from any Stimulus code that needs
// to behave differently in the embed.
export function isMoEmbedded() {
  return document.body?.hasAttribute("data-mo-embedded") ?? false;
}

// The parent page URL (Salespath) the shell was opened with, stamped as `data-mo-parent-url` on
// <body>. Reported as Mo's page context in the embed, where the iframe's own pathname is always
// /admin/massimo/embed and so meaningless. Null when Salespath omitted it, or outside the embed.
export function moEmbedParentUrl() {
  return document.body?.dataset.moParentUrl || null;
}
